import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { site } from "@/mocks/site";

const quickLinks = [
  { label: "首页", path: "/" },
  { label: "关于我们", path: "/about" },
  { label: "联系我们", path: "/contact" },
  { label: "瓜友投稿", path: "/contact" },
];

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-20 bg-secondary-900 text-background-100">
      <div className="mx-auto max-w-[1400px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <Link to="/" className="mb-4 flex items-center gap-2.5 cursor-pointer">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-lg" />
              </span>
              <span className="font-heading text-xl font-bold tracking-wide text-background-50">
                {site.name}
              </span>
            </Link>
            <p className="text-sm leading-relaxed text-background-300">{site.description}</p>
            <div className="mt-5 flex items-center gap-3">
              {[
                { icon: "ri-wechat-line", label: "微信公众号" },
                { icon: "ri-weibo-line", label: "微博" },
                { icon: "ri-mail-line", label: "邮件订阅" },
              ].map((item) => (
                <span
                  key={item.label}
                  className="flex h-9 w-9 items-center justify-center rounded-md border border-background-100/15 text-background-200 transition-colors hover:border-accent-500 hover:text-accent-400"
                  aria-label={item.label}
                >
                  <i className={`${item.icon} text-base`} />
                </span>
              ))}
            </div>
          </div>

          <div>
            <h2 className="mb-4 font-heading text-base font-semibold text-background-50">
              瓜类栏目
            </h2>
            <ul className="space-y-2.5">
              {categories.map((item) => (
                <li key={item.slug}>
                  <Link
                    to={`/category/${item.slug}`}
                    className="text-sm text-background-300 transition-colors hover:text-accent-400 cursor-pointer"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h2 className="mb-4 font-heading text-base font-semibold text-background-50">
              站内导航
            </h2>
            <ul className="space-y-2.5">
              {quickLinks.map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.path}
                    className="text-sm text-background-300 transition-colors hover:text-accent-400 cursor-pointer"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h2 className="mb-4 font-heading text-base font-semibold text-background-50">
              爆料与反馈
            </h2>
            <p className="mb-3 text-sm leading-relaxed text-background-300">
              有瓜想投？附上原帖链接、截图与时间，材料越完整越容易被整理成时间线。
            </p>
            <a
              href={`mailto:${site.contactEmail}`}
              className="mb-4 inline-flex items-center gap-2 whitespace-nowrap text-sm text-accent-400 hover:text-accent-300"
            >
              <i className="ri-mail-send-line" />
              {site.contactEmail}
            </a>
            <div>
              <Link
                to="/contact"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
              >
                <i className="ri-send-plane-fill" />
                前往投稿
              </Link>
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-background-100/10 pt-6 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} {site.name} · {site.tagline}　本站内容均基于公开信息整理，仅供参考。</p>
          <p className="flex flex-wrap items-center gap-4">
            <span>始于 {site.since} 年</span>
            <span>累计归档 {site.coverCount}+ 条瓜帖</span>
          </p>
        </div>
      </div>
    </footer>
  );
}